import React from 'react';
import propTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import 'Components/HallOfFame/InlineMetaCriticLogo.scss';


export default function InlineMetaCriticLogoi({ siteTheme }) {
  const titleLogo = siteTheme === 'dark' ? 'https://cdn.fanatical.com/production/brand/metacritic/svg/metacritic-text-white.svg' : 'https://cdn.fanatical.com/production/brand/metacritic/svg/metacritic-text-black.svg';
  const logo = 'https://cdn.fanatical.com/production/brand/metacritic/svg/metacritic-icon.svg';

  return (
    <div className="InlineMetaCriticLogo">
      <div className="InlineMetaCriticLogo__poweredBy">
        <FormattedMessage id="inlinemetacriticlogo.poweredby" defaultMessage="Powered by" />
      </div>
      <div className="InlineMetaCriticLogo__logoContainer">
        <img
          className="InlineMetaCriticLogo__logoLogo"
          src={logo}
          width="34px"
          alt="MetaCritic Logo"
        />

        <img
          src={titleLogo}
          width="100px"
          height="18px"
          alt="Powered by MetaCritic"
        />
      </div>
    </div>
  );
}

InlineMetaCriticLogoi.propTypes = {
  siteTheme: propTypes.string,
};

InlineMetaCriticLogoi.defaultProps = {
  siteTheme: 'dark',
};
